/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './communication-log.reducer';

export const CommunicationLogDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const communicationLogEntity = useAppSelector(state => state.communicationLog.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="communicationLogDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.communicationLog.detail.title">CommunicationLog</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.communicationLog.id">Id</Translate>
            </span>
            <UncontrolledTooltip target="id">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.id" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.id}</dd>
          <dt>
            <span id="recepient">
              <Translate contentKey="tinyMedicRestApp.communicationLog.recepient">Recepient</Translate>
            </span>
            <UncontrolledTooltip target="recepient">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.recepient" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.recepient}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.communicationLog.status">Status</Translate>
            </span>
            <UncontrolledTooltip target="status">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.status" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.status}</dd>
          <dt>
            <span id="noOfRetries">
              <Translate contentKey="tinyMedicRestApp.communicationLog.noOfRetries">No Of Retries</Translate>
            </span>
            <UncontrolledTooltip target="noOfRetries">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.noOfRetries" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.noOfRetries}</dd>
          <dt>
            <span id="requestURI">
              <Translate contentKey="tinyMedicRestApp.communicationLog.requestURI">Request URI</Translate>
            </span>
            <UncontrolledTooltip target="requestURI">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.requestURI" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.requestURI}</dd>
          <dt>
            <span id="requestMsg">
              <Translate contentKey="tinyMedicRestApp.communicationLog.requestMsg">Request Msg</Translate>
            </span>
            <UncontrolledTooltip target="requestMsg">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.requestMsg" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.requestMsg}</dd>
          <dt>
            <span id="requestStartTime">
              <Translate contentKey="tinyMedicRestApp.communicationLog.requestStartTime">Request Start Time</Translate>
            </span>
            <UncontrolledTooltip target="requestStartTime">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.requestStartTime" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.requestStartTime}</dd>
          <dt>
            <span id="responseStartTime">
              <Translate contentKey="tinyMedicRestApp.communicationLog.responseStartTime">Response Start Time</Translate>
            </span>
            <UncontrolledTooltip target="responseStartTime">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.responseStartTime" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.responseStartTime}</dd>
          <dt>
            <span id="responseCode">
              <Translate contentKey="tinyMedicRestApp.communicationLog.responseCode">Response Code</Translate>
            </span>
            <UncontrolledTooltip target="responseCode">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.responseCode" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.responseCode}</dd>
          <dt>
            <span id="responseMsg">
              <Translate contentKey="tinyMedicRestApp.communicationLog.responseMsg">Response Msg</Translate>
            </span>
            <UncontrolledTooltip target="responseMsg">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.responseMsg" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.responseMsg}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.communicationLog.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.communicationLog.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.communicationLog.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.communicationLog.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.communicationLog.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.timestampEntry}</dd>
          <dt>
            <span id="eventName">
              <Translate contentKey="tinyMedicRestApp.communicationLog.eventName">Event Name</Translate>
            </span>
            <UncontrolledTooltip target="eventName">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.eventName" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.eventName}</dd>
          <dt>
            <span id="operationType">
              <Translate contentKey="tinyMedicRestApp.communicationLog.operationType">Operation Type</Translate>
            </span>
            <UncontrolledTooltip target="operationType">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.operationType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.operationType}</dd>
          <dt>
            <span id="tenantId">
              <Translate contentKey="tinyMedicRestApp.communicationLog.tenantId">Tenant Id</Translate>
            </span>
            <UncontrolledTooltip target="tenantId">
              <Translate contentKey="tinyMedicRestApp.communicationLog.help.tenantId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{communicationLogEntity.tenantId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.communicationLog.channel">Channel</Translate>
          </dt>
          <dd>{communicationLogEntity.channel ? communicationLogEntity.channel.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.communicationLog.template">Template</Translate>
          </dt>
          <dd>{communicationLogEntity.template ? communicationLogEntity.template.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/communication-log" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/communication-log/${communicationLogEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CommunicationLogDetail;
